import { render, staticRenderFns } from "./UserSelectDialog.vue?vue&type=template&id=0d8fab2e&"
import script from "./UserSelectDialog.vue?vue&type=script&lang=js&"
export * from "./UserSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports